const BinaryParser = require('mongo-binary-parser')

class FluxStories {
  constructor(document) {
    document = document || {}
    this.enabled = typeof document.enabled === 'undefined' ? true : document.enabled
    this.transition = document.transition
    this.medias = document.medias || []
    this.medias.forEach( media => media._id = BinaryParser.BinaryToGUID(media._id))
  }
}

module.exports = FluxStories
